import type { DevSettingsRecord } from '@navio/nsdk';
import { type AdapterEnv, asAdapterEnv } from 'noddi-util';

/** Adapter API env from DevSettings (nsdk still exposes `eontyreEnv`). */
export const devSettingsAdapterEnv = (devSettings: DevSettingsRecord | undefined): AdapterEnv | undefined => {
  return asAdapterEnv(devSettings?.eontyreEnv) ?? undefined;
};
